module.exports = __webpack_public_path__ + "static/media/call-back.7124bed5.svg";